export const tr = {
    RUB: 'Rus Rublesi',
    currency: 'Döviz',
    default: 'hayır',
    from: 'min.',
    prefix: 'Ön ek',
    price: 'Fiyat',
    priceOld: 'Eski fiyat',
    to: 'maks.'
};
